import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { createOrder } from '../services/api';

function formatRupiah(n) { return 'Rp ' + n.toLocaleString('id-ID'); }

export default function CheckoutPage() {
  const { cart, totalPrice, totalItems, clearCart } = useCart();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ name: '', phone: '', note: '' });

  const handleChange = e => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) return setError('Nama dan nomor HP wajib diisi');
    setLoading(true); setError('');
    try {
      const res = await createOrder({ customer: form, items: cart.map(i => ({ productId: i.productId, quantity: i.quantity })) });
      clearCart();
      navigate(`/payment/${res.data.data.orderId}`, { state: res.data.data });
    } catch (err) {
      setError(err.response?.data?.error || 'Gagal membuat pesanan. Coba lagi.');
    }
    setLoading(false);
  };

  if (cart.length === 0) return (
    <div className="empty-state page-enter"><span className="empty-icon">🛒</span><p>Keranjang kosong.</p><Link to="/" className="btn btn-primary">Belanja dulu</Link></div>
  );

  return (
    <div className="page-enter">
      <div className="page-title">Checkout</div>
      <div className="two-col">
        <div className="section-box">
          <div className="sec-title">// data pemesan</div>
          {error && <div className="alert alert-error">⚠️ {error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Nama Lengkap *</label>
              <input name="name" className="form-control" placeholder="Masukkan nama lengkap" value={form.name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label className="form-label">Nomor HP / WhatsApp *</label>
              <input name="phone" className="form-control" placeholder="08xxxxxxxxxx" value={form.phone} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label className="form-label">Catatan <span style={{ color: 'var(--text3)', fontWeight: 400 }}>(opsional)</span></label>
              <textarea name="note" className="form-control" placeholder="Instruksi khusus..." value={form.note} onChange={handleChange} />
            </div>
            <button type="submit" className="btn btn-primary btn-full" disabled={loading} style={{ marginTop: 6 }}>
              {loading ? '⏳ Memproses...' : '⚡ Bayar dengan QRIS'}
            </button>
          </form>
        </div>

        <div className="section-box">
          <div className="sec-title">// pesanan</div>
          {cart.map(item => (
            <div key={item.productId} className="sum-row">
              <span style={{ fontSize: '0.83rem' }}>{item.name} ×{item.quantity}</span>
              <span style={{ fontFamily: 'var(--mono)', fontSize: '0.83rem' }}>{formatRupiah(item.price * item.quantity)}</span>
            </div>
          ))}
          <div className="sum-row">
            <span>Total ({totalItems} item)</span>
            <span>{formatRupiah(totalPrice)}</span>
          </div>
          <div className="alert alert-warning" style={{ marginTop: 16, fontSize: '0.8rem' }}>
            ⚠️ Biaya layanan PakAsir akan ditampilkan di halaman pembayaran.
          </div>
        </div>
      </div>
    </div>
  );
}
